<template>
  <Modal :is-modal-open="showModal" @close="closeModal">
    <div class="md:flex h-full w-full">
      <TemplateAside class="flex-shrink-0" @toggle="toggle" />

      <div v-for="item in map" :key="item.activeState" :class="{'h-full w-full': activeState === item.activeState}">
        <SavedTemplates
          v-if="!showAside && activeState === item.activeState"
          :title="item.title"
          :type="item.type"
          :editor="editor"
          @back="toggle"
        />
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/shared/Modal'
import TemplateAside from '@/components/templates/TemplateAside'
import SavedTemplates from '@/components/templates/SavedTemplates'

import { useStore } from 'vuex'
import { defineComponent, computed, nextTick } from 'vue'

export default defineComponent({
  components: { Modal, TemplateAside, SavedTemplates },

  props: {
    editor: Object
  },

  setup () {
    const { commit, state, getters } = useStore()

    const activeState = computed(() => state.template.activeState)
    const showModal = computed(() => state.template.showModal)
    const showAside = computed(() => state.template.showAside)
    const isMobile = computed(() => getters.isMobile)

    const map = [
      {
        type: 'all',
        title: 'All templates',
        activeState: 'All'
      },
      {
        type: 'all',
        title: 'Template library',
        activeState: 'Library'
      },
      {
        type: 'private',
        title: 'My templates',
        activeState: 'Private'
      },
      {
        type: 'shared',
        title: 'Shared templates',
        activeState: 'Shared'
      }
    ]

    commit('toggleTemplateAside', isMobile.value)

    function closeModal () {
      commit('toggleTemplateModal', false)

      nextTick(() => {
        commit('toggleTemplateAside', isMobile.value)
      })
    }

    function toggle () {
      commit('toggleTemplateAside', !showAside.value)
    }

    return {
      activeState,
      showModal,
      showAside,
      isMobile,
      map,
      toggle,
      closeModal
    }
  }
})
</script>
